export default {
  undefined: 'Undefined',
};
